import { useTranslation } from 'next-i18next';

const useRentalWidgetContent = () => {
  const { t } = useTranslation('fe_er_common_main_widget');

  return {
    baseErrorHeader: t('fe_er_common_main_widget:base_error_header'),
    pickupLocation: t('fe_er_common_main_widget:pickup_location'),
    choosePickupLocation: t('fe_er_common_main_widget:choose_pickup_location'),
    returnToDifferentLocation: t(
      'fe_er_common_main_widget:return_to_different_location',
    ),
    dropoffLocation: t('fe_er_common_main_widget:dropoff_location'),
    chooseDropoffLocation: t(
      'fe_er_common_main_widget:choose_dropoff_location',
    ),
    sameAsPickupLocation: t('fe_er_common_main_widget:same_as_pickup_location'),
    pickupDateLabel: t('fe_er_common_main_widget:pickup_date_label'),
    dropoffDateLabel: t('fe_er_common_main_widget:dropoff_date_label'),
    searchNow: t('fe_er_common_main_widget:search_now'),
    startYourReservation: t('fe_er_common_main_widget:start_your_reservation'),
  };
};

export { useRentalWidgetContent };
